module.exports = __webpack_public_path__ + "img/barracuda.lg.e4cb9740.svg";